<header>
  <!-- LEFT -->
  <div><ng-content></ng-content></div>

  <!-- RIGHT -->
  <button
    mat-icon-button
    disableRipple
    [matMenuTriggerFor]="langMenu"
    id="language-selector-btn"
    *ngIf="localeId !== 'de'"
  >
    <mat-icon>language</mat-icon>
  </button>
</header>

<mat-menu #langMenu="matMenu" xPosition="before">
  <a mat-menu-item href="/en{{ router.url }}" [disabled]="localeId === 'en'"> English </a>
  <a mat-menu-item href="/es{{ router.url }}" [disabled]="localeId === 'es'"> Español </a>
</mat-menu>
